export default __webpack_public_path__ + "static/media/NL.62fcfad8.svg";